var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.item.value.notEndedOrdersCount
        ? _c("icon", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover",
                modifiers: { hover: true }
              }
            ],
            attrs: {
              name: "car-side",
              title:
                "Количество активных заказов: " +
                _vm.item.value.notEndedOrdersCount
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.item.courier === "Самовывоз"
        ? _c("icon", { attrs: { name: "people-carry" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.getItemType(_vm.item.item) === "order"
        ? _c(
            "b-badge",
            {
              staticClass: "order-row__status stage",
              attrs: {
                variant: _vm.getOrderBadgeVariant(
                  _vm.item.item.order.status.keyword
                )
              }
            },
            [_vm._v(_vm._s(_vm.item.item.order.status.name))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getItemType(_vm.item.item) === "order" &&
      _vm.item.item.order.autoAssignCourier
        ? _c("b-badge", { staticClass: "order-row__status" }, [
            _vm._v("Назначено автоматически")
          ])
        : _vm._e(),
      _vm._v("\n    " + _vm._s(_vm.getOrderTitle(_vm.item.item)) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6055af7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6055af7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordersDelivery/OrderRow.vue
// module id = null
// module chunks = 